<template>
  <b-form-group
    label="Miktar"
    label-for="quantity"
  >
    <validation-provider
      #default="{ errors }"
      name="Miktar"
      rules="required"
    >
      <cleave
        v-model="dataItem.quantity"
        class="form-control"
        :raw="true"
        :options="options.number"
        placeholder="Miktar"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import {
  BFormGroup,
} from 'bootstrap-vue'

export default {
  name: 'QuantityCard',
  components: {
    Cleave,
    ValidationProvider,
    BFormGroup,
  },
  data() {
    return {
      required,
      options: {
        number: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['servicePrices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
